import { COLORS } from '@btime/constants'
import React from 'react'

import { FlexCol } from '../../../../../components/structure/FlexGrid'
import { useChecklistFormActions } from '../../_form/ChecklistFormHandler'
import Center from '../../../../../components/helpers/Center'
import Icon from '../../../../../components/shapes/Icon'
import Link from '../../../../../components/actions/Link'

const CategoryActions = ({ category, index }) => {
  const { duplicateCategory, openTriggersCategoryCheckModal } = useChecklistFormActions()

  return (
    <>
      <FlexCol>
        <Link block onClick={() => duplicateCategory(index)}>
          <Center>
            <Icon name="BsLayers" size="1rem" color={COLORS.dark3} />
          </Center>
        </Link>
      </FlexCol>

      <FlexCol>
        <Link block onClick={() => openTriggersCategoryCheckModal(index)}>
          <Center>
            <Icon name="BsTrash" size="1rem" color={COLORS.red} />
          </Center>
        </Link>
      </FlexCol>
    </>
  )
}

export default CategoryActions
